module.exports = __webpack_public_path__ + "img/logo-vendor.04633402.svg";